import { Injectable } from '@angular/core';
import type { BaseWidget, WidgetConstructor } from '../../model';
import { BaseWidgetFactory } from '../../widget-factory';

export interface DomWidgetConstructor extends WidgetConstructor {
  new (container: HTMLElement): BaseWidget;
}

@Injectable()
export class DomWidgetFactoryService extends BaseWidgetFactory<DomWidgetConstructor> {
  protected override instantiate(WidgetClass: DomWidgetConstructor, container: HTMLElement): BaseWidget {
    return new WidgetClass(container);
  }

  override async loadFramework(): Promise<undefined> {
    return undefined;
  }
}
